import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { saveAs } from '@progress/kendo-file-saver';
import { map, catchError, of } from 'rxjs';
import { UI_LABELS } from 'src/app/core/constants/lables.constants';
import { ApiHandler } from 'src/app/core/services/api.handler';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-recurring-invite',
  templateUrl: './recurring-invite.component.html',
  styleUrls: ['./recurring-invite.component.scss']
})
export class RecurringInviteComponent implements OnInit,OnDestroy {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private apiHandler: ApiHandler,
    private http: HttpClient
  ) {}
  ngOnDestroy(): void {
    sessionStorage.removeItem('isShowQRCode');
  }
  readonly labels = UI_LABELS;
  token: string;
  id:string;
  invite: any = {};
  isShowQRCode:boolean=false;
  ngOnInit(): void {
    this.invite = this.route.snapshot.data['data'];
    if(this.invite.InviteType=='Temporary')
    {
      this.isShowQRCode=true;
    }
    this.route.queryParams.subscribe((params: any) => {
      this.token = params.d;
      this.id = params.id;
    });
    this.downloadQrCode();
  }

  private downloadQrCode(): void {
    const base64Data = this.invite && this.invite.Result;
    if (!this.invite || !this.invite.Status || typeof base64Data !== 'string') {
      return;
    }
    const normalized = base64Data.replace(/\s/g, '');
    if (!/^[A-Za-z0-9+/]+={0,2}$/.test(normalized) || normalized.length % 4 !== 0) {
      return;
    }
    const rawName = typeof this.invite.DownloadName === 'string' ? this.invite.DownloadName : 'qrcode.png';
    const baseName = rawName.split(/[/\\]/).pop() || 'qrcode.png';
    const safeName = baseName.replace(/[^A-Za-z0-9._-]/g, '');
    const downloadName = safeName.toLowerCase().endsWith('.png') ? safeName : (safeName || 'qrcode') + '.png';
    let binary: string;
    try {
      binary = window.atob(normalized);
    } catch {
      return;
    }
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
      bytes[i] = binary.charCodeAt(i);
    }
    const objectUrl = URL.createObjectURL(new Blob([bytes], { type: 'image/png' }));
    const anchor = document.createElement('a');
    anchor.href = objectUrl;
    anchor.download = downloadName;
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
    window.setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
  }


  private handleError(error: any) {
    return of(error.error);
  }

}
